import { FC } from 'react';

export type HyperLinkIconProps = {};

export const HyperlinkIcon: FC<HyperLinkIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 10.6666C4 12.1394 5.19391 13.3333 6.66667 13.3333H9.33333C10.8061 13.3333 12 12.1394 12 10.6666C12 9.19387 10.8061 7.99996 9.33333 7.99996M12 5.33329C12 3.86053 10.8061 2.66663 9.33333 2.66663H6.66667C5.19391 2.66663 4 3.86053 4 5.33329M2 7.99996H14"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
